import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { CompressionService } from '../compression.service';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import * as shape from 'd3-shape';

@Component({
  selector: 'app-letter-compression',
  templateUrl: './letter-compression.component.html',
  styleUrls: ['./letter-compression.component.css']
})
export class LetterCompressionComponent extends GeneralExerciseComponent {

  text: string;
  compressedText: string;
  modus: string;
  mapping: string[][];

  errors: number[] = [];
  solution: string;

  toHighlight: number;
  caretPosition: number;
  position: number[];

  nodes: any[];
  edges: any[];

  view: any[] = [600, 300];
  fitContainer: boolean = true;
  curve = shape.curveBundle;

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService, protected compressionService: CompressionService) {
    super(activatedRoute, topicService, messageService)
  }

  setTypeSpecificsFromConfiguration() {
    this.text = this.configuration.typespecifics.text;
    this.modus = this.configuration.typespecifics.modus;
    this.mapping = this.configuration.typespecifics.mapping;

    this.compressedText = "";

    let graph = this.compressionService.computeTree(this.mapping);
    this.nodes = graph.nodes;
    this.edges = graph.edges;

    this.position = [];
    let index = 0;
    let map0 = this.mapping.map(v => v[0]);
    for(let c of this.text){
      let i = map0.indexOf(c);
      for(let j = 0; j < this.mapping[i][1].length; j++){
        this.position.push(index);
      }
      index ++;
    }

    this.printable = true;
  }

  setTypeSpecificsFromState() {
    if (this.state.typespecific) {
      if (this.state.typespecific.compressedText) {
        this.compressedText = this.state.typespecific.compressedText;
      }
    }
  }

  computeState() {
    this.state.typespecific.compressedText = this.compressedText;
  }

  checkSolution() {
    this.solution = this.compressionService.compressLetter(this.text, this.mapping);
    let studentSolution = this.compressedText.split("");
    this.errors = this.solution.split("").map((v, i) => [v, i]).filter(v => v[0] != studentSolution[v[1]]).map(v => +v[1]).map(v => this.position[v]);

    console.log(this.errors);

    if (this.errors.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("wrongAnswer"), "danger", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      this.solved = true;
      this.state.solved = true;
      this.saveState();
    }
  }

  evaluate(): number[] {
    this.solution = this.compressionService.compressLetter(this.text, this.mapping);
    let studentSolution = this.compressedText.split("");
    let errors = this.solution.split("").map((v, i) => [v, i]).filter(v => v[0] != studentSolution[v[1]]).map(v => +v[1]).map(v => this.position[v]);

    return [(this.solution.length-errors.length)/5, this.solution.length / 5];
  }

  /** on typing, set highlighted parts */
  setCaret(oField) {
    if (oField.selectionStart || oField.selectionStart == '0') {
      this.caretPosition = oField.selectionStart;
    }
    this.toHighlight = this.position[this.caretPosition];
  }

  /** is given wird errorneous? */
  inError(i: number) {
    return this.errors.includes(i);
  }

  /** remove all char other than 0 and 1 */
  normalizeText() {
    this.compressedText = this.compressedText.replace(/[^01]/gi, '').replace(/\s+/, " ");
  }




}
